import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { ContactForm } from "@/components/ContactForm";

export const Contact = () => {
  const { t } = useLanguage();
  const c = t.scuba.contact;
  return (
    <section id="contact" className="relative bg-ocean-deep py-28 md:py-36 px-6 md:px-12 lg:px-20 border-t border-white/10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-mono text-cyan-300 text-xs tracking-[0.25em] mb-4" data-testid="scuba-contact-eyebrow">
            {c.eyebrow}
          </p>
          <h2 className="font-syne text-4xl md:text-5xl tracking-tight text-white mb-6">{c.title}</h2>
          <p className="font-manrope text-white/65 leading-relaxed max-w-md">{c.subtitle}</p>
        </motion.div>
        <ContactForm
          theme="ocean"
          brand="scuba"
          fields={[
            { name: "name", label: c.form.name, type: "text" },
            { name: "email", label: c.form.email, type: "email" },
          ]}
          messageLabel={c.form.message}
          submitLabel={c.form.submit}
          successMessage={c.form.success}
          errorMessage={c.form.error}
          testidPrefix="scuba-contact"
        />
      </div>
    </section>
  );
};
